import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/achievements";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u062f\u0631\u06cc\u0627\u0641\u062a \u062f\u0627\u062f\u0647";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getUserBadges() {
  return request("/user/badges/");
}

export function getChallengeCertificates() {
  return request("/user/challenge-certificates/");
}

export function getWithdrawalCertificates() {
  return request("/user/withdrawal-certificates/");
}
